import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

interface SelectRingToggleIconProps extends IconProps {
  ringMode?: boolean;
}

export const SelectRingToggleIcon = React.memo<SelectRingToggleIconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5, ringMode = false }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {ringMode ? (
        <>
          {/* Ring mode: 3D torus selected */}
          {/* Outer ellipse */}
          <ellipse cx="12" cy="12" rx="9" ry="5" stroke={color} strokeWidth={strokeWidth} fill="none" />
          {/* Inner ellipse */}
          <ellipse cx="12" cy="12" rx="4" ry="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
          {/* Ring fill (selected) */}
          <path
            d="M12 7c-5 0-9 2.2-9 5s4 5 9 5 9-2.2 9-5-4-5-9-5zM12 10c2.2 0 4 .9 4 2s-1.8 2-4 2-4-.9-4-2 1.8-2 4-2z"
            fill={color}
            fillRule="evenodd"
          />
          {/* Selection indicator */}
          <circle cx="12" cy="12" r="1" fill="none" stroke={color} strokeWidth={1} />
        </>
      ) : (
        <>
          {/* Point mode: Gaussian splat point selected */}
          {/* Core (selected - filled) */}
          <ellipse cx="12" cy="12" rx="3" ry="2" fill={color} />
          {/* Outer rings (unselected - just outline) */}
          <ellipse cx="12" cy="12" rx="6" ry="4" stroke={color} strokeWidth={strokeWidth} fill="none" opacity="0.5" />
          <ellipse cx="12" cy="12" rx="9" ry="5.5" stroke={color} strokeWidth={strokeWidth} fill="none" opacity="0.3" />
        </>
      )}
    </BaseIcon>
  ),
);

SelectRingToggleIcon.displayName = 'SelectRingToggleIcon';
